import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import CONSTANTS from "../constants"

import classic from "../images/classic.jpg"
import full from "../images/full.jpg"

const title = "La Pagaie d'Aure | rafting St Lary"
const description = "Rafting dans les Pyrénées à Saint-Lary-Soulan, sur la Neste d'Aure. 100% fun et dépaysant !"
const keywords = "rafting, saint-lary, st lary, pyrénées"

const date = new Date()
date.setMonth(11)
date.setDate(31)
const endOfYear = date.toISOString().substring(0, 10) // YYYY-MM-DD

const structuredContent = {
  "@context": "http://schema.org",
  "@type": "ItemList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@type": "product",
        name: "Descente en rafting ou mini-raft",
        brand: {
          "@type": "Brand",
          name: "La Pagaie d'Aure",
        },
        image: "https://" + CONSTANTS.hostname + classic,
        description:
          "Venez tester le rafting en vallée d’Aure, une activité de montagne accessible, ludique, aquatique et en pleine nature. 1h30 à 1h45 de navigation et péripéties à bord de ce gros bateau gonflable pour un dépaysement total ! En famille ou entre amis, venez faire un tour de rafting sur l’artère de la vallée, la belle Neste d’Aure.",
        offers: {
          "@type": "Offer",
          priceCurrency: "EUR",
          price: CONSTANTS.price,
          availability: "http://schema.org/InStock",
          seller: {
            "@type": "Organization",
            name: "La Pagaie d'Aure",
          },
          priceValidUntil: endOfYear,
          sku: "rafting",
        },
        url: "https://www.lapagaiedaure.com/rafting-saint-lary/#rafting",
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@type": "product",
        name: "Descente en canoraft (airboat / hot-dog)",
        brand: {
          "@type": "Brand",
          name: "La Pagaie d'Aure",
        },
        image: "https://" + CONSTANTS.hostname + classic,
        description:
          "À deux ou en solo, ces petites embarcations gonflables cousines du raft, aussi appelées airboat ou hot-dog, vous permettront une approche plus autonome et dynamique sur le même parcours, avec une petite surprise à mi-chemin. Déconseillé aux couples fragiles 😜",
        offers: {
          "@type": "Offer",
          priceCurrency: "EUR",
          price: CONSTANTS.price,
          availability: "http://schema.org/InStock",
          seller: {
            "@type": "Organization",
            name: "La Pagaie d'Aure",
          },
          priceValidUntil: endOfYear,
          sku: "canoraft",
        },
        url: "https://www.lapagaiedaure.com/rafting-saint-lary/#canoraft",
      },
    },
    {
      "@type": "ListItem",
      position: 3,
      item: {
        "@type": "product",
        name: "Descente en hydrospeed (nage en eau vive)",
        brand: {
          "@type": "Brand",
          name: "La Pagaie d'Aure",
        },
        image: "https://" + CONSTANTS.hostname + classic,
        description:
          "Aussi appelé nage en eau vive, les palmes et cet engin très maniable au début créé pour les secours en eau vive, permettent une approche différente de la rivière. Plus physique que les bateaux gonflables, l’hydrospeed permet d’appréhender et de mieux comprendre les mouvements d’eau et les courants, tout en étant en immersion totale ! Attention, pour apprécier un maximum il est conseillé d’avoir déjà utilisé des palmes, et vous devez avoir 14 ans minimum !",
        offers: {
          "@type": "Offer",
          priceCurrency: "EUR",
          price: CONSTANTS.price,
          availability: "http://schema.org/InStock",
          seller: {
            "@type": "Organization",
            name: "La Pagaie d'Aure",
          },
          priceValidUntil: endOfYear,
          sku: "hydrospeed",
        },
        url: "https://www.lapagaiedaure.com/rafting-saint-lary/#hydrospeed",
      },
    },
  ],
}

const SEO = ({ robots }) => (
  <Helmet htmlAttributes={{ lang: "fr" }}>
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <meta name="description" property="og:description" content={description} />
    <meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:description" content={description} />
    <meta name="robots" content={robots} />
    <meta name="keywords" content={keywords} />
    <script type="application/ld+json">{JSON.stringify(structuredContent)}</script>
  </Helmet>
)

SEO.defaultProps = {
  robots: "noindex, nofollow",
}

SEO.propTypes = {
  robots: PropTypes.string,
}

export default SEO
